import { render, staticRenderFns } from "./urgentDeal.vue?vue&type=template&id=0a80e266&scoped=true&"
import script from "./urgentDeal.vue?vue&type=script&lang=js&"
export * from "./urgentDeal.vue?vue&type=script&lang=js&"
import style0 from "./urgentDeal.vue?vue&type=style&index=0&id=0a80e266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80e266",
  null
  
)

export default component.exports